import { assignmentTypes } from 'constants/index';
import { invertObj } from 'ramda';

export const isFactualFluency = typeId => {
  const assignmentTypeName = invertObj(assignmentTypes)[typeId];
  const factualFluencyTime = ['total', 'interval', 'notime'];

  return factualFluencyTime.includes(assignmentTypeName);
};
